function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.75 9.25c.41 0 .75.34.75.75s-.34.75-.75.75H8.5V13c0 1.24 1.01 2.25 2.25 2.25h5c.41 0 .75.34.75.75s-.34.75-.75.75h-5C8.68 16.75 7 15.07 7 13v-2c0-2.07 1.68-3.75 3.75-3.75h5c.41 0 .75.34.75.75s-.34.75-.75.75h-5C9.51 8.75 8.5 9.76 8.5 11v.25h7.25z"
})));